/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Data_QuestionInputs */

const en_faq_data_question = /** @type {(inputs: Faq_Data_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do we decide what data the system can access?`)
};

const lv_faq_data_question = /** @type {(inputs: Faq_Data_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā nosakām, kādiem datiem sistēma var piekļūt?`)
};

/**
* | output |
* | --- |
* | "How do we decide what data the system can access?" |
*
* @param {Faq_Data_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_data_question = /** @type {((inputs?: Faq_Data_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Data_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_data_question(inputs)
	return en_faq_data_question(inputs)
});